module.exports = __webpack_public_path__ + "static/media/footer_6.81084f2e.png";